// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__oPuPt","checkboxCol":"Table_checkboxCol__3y5NI","emailCol":"Table_emailCol__3V-6v","actionCol":"Table_actionCol__RawAb"};